var toString = {}.toString;
var isType = function (value, type) { return toString.call(value) === '[object ' + type + ']'; };
export default isType;
//# sourceMappingURL=is-type.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/esm/is-type.js
// module id = null
// module chunks = 